import { useState } from 'react'
import * as hub from '../hub/roomHub'
import { roomStore } from '../store/room'
import '../css/App.css'

interface Props {
  onClose:   () => void
  onJoined:  (roomCode: string) => void
}

export default function JoinByCodeModal({ onClose, onJoined }: Props) {
  const [code,     setCode]    = useState('')
  const [password, setPassword] = useState('')
  const [busy,     setBusy]    = useState(false)
  const [errMsg,   setErrMsg]  = useState('')

  async function handleJoin() {
    const trimCode = code.trim().toUpperCase()
    if (trimCode.length !== 6) {
      setErrMsg('룸코드는 6자리입니다.')
      return
    }
    setBusy(true)
    setErrMsg('')

    const result = await new Promise<{ ok: boolean; msg?: string }>(resolve => {
      const onDetail = (data: unknown) => {
        const d = data as Parameters<typeof roomStore.applyDetail>[0]
        if (d?.room && d?.members) roomStore.applyDetail(d)
        hub.off('RoomDetail', onDetail as (...a: unknown[]) => void)
        hub.off('Error',      onError  as (...a: unknown[]) => void)
        resolve({ ok: true })
      }
      const onError = (data: unknown) => {
        const d = data as { action?: string; msg?: string }
        if (d.action !== 'RoomJoin') return
        hub.off('RoomDetail', onDetail as (...a: unknown[]) => void)
        hub.off('Error',      onError  as (...a: unknown[]) => void)
        resolve({ ok: false, msg: d.msg ?? '입장 실패' })
      }

      hub.on('RoomDetail', onDetail as (...a: unknown[]) => void)
      hub.on('Error',      onError  as (...a: unknown[]) => void)

      hub.roomJoin(trimCode, password || null).catch(err => {
        hub.off('RoomDetail', onDetail as (...a: unknown[]) => void)
        hub.off('Error',      onError  as (...a: unknown[]) => void)
        resolve({ ok: false, msg: (err as Error).message ?? '연결 오류' })
      })
    })

    setBusy(false)
    if (result.ok) {
      onJoined(trimCode)
    } else {
      setErrMsg(result.msg ?? '입장 실패')
    }
  }

  function handleKeyDown(e: React.KeyboardEvent) {
    if (e.key === 'Enter') handleJoin()
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <h3 className="modal-title">코드로 입장</h3>

        <label className="modal-label">룸코드 (6자리)</label>
        <input
          className="modal-input code-input"
          type="text"
          maxLength={6}
          placeholder="예: AB23CD"
          value={code}
          onChange={e => setCode(e.target.value.toUpperCase())}
          onKeyDown={handleKeyDown}
          disabled={busy}
          autoFocus
        />

        <label className="modal-label">비밀번호 (비공개 방)</label>
        <input
          className="modal-input"
          type="password"
          placeholder="비공개 방이 아니면 비워두세요"
          value={password}
          onChange={e => setPassword(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={busy}
        />

        {errMsg && <p className="modal-err">{errMsg}</p>}

        <div className="modal-btns">
          <button className="btn-cancel" onClick={onClose} disabled={busy}>취소</button>
          <button className="btn-primary" onClick={handleJoin} disabled={busy}>
            {busy ? <span className="spinner" /> : null}입장
          </button>
        </div>
      </div>
    </div>
  )
}
